

import React from "react"
import './TextDivider.scss'

export const TextDivider = (props) => {
    return (<div {...props} className="separator">{props.children}</div>)
}